import { faCheck, faExclamationTriangle, faClose, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Box, Snackbar } from "@mui/material";
import { useState } from "react";
import styles from "../../../SolicitacaoAcessoAnalise/SolicitacaoAcessoAnalise.module.css";
import { PopupTexto } from "../../../../components/PopupTexto/PopupTexto";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { base64toBlob } from "../../../../infra/utils/Files";
import servAnalises from "../../../../services/login/servAnalises";

const SITUACAO_LABEL = {
    0: "Não avaliado",
    1: "Favorável",
    2: "Favorável com Ressalvas",
    3: "Reprovada",
};

const SITUACAO_ICON = {
    0: faPen,
    1: faCheck,
    2: faExclamationTriangle,
    3: faClose,
};

const SituacaoAnalise = ({ tipoParecer, parecer, motivoReprovacao, ressalva, projeto, onDownloadParecer }) => {
    const situacaoLabel = SITUACAO_LABEL[parecer] ?? "Não avaliado";
    const situacaoIcon = SITUACAO_ICON[parecer];

    const documentos = projeto?.Documentos || [];
    const projetoId = projeto?.Id;

    const observacao =
        parecer === 2 && ressalva ? { label: "Ressalva", texto: ressalva }
            : parecer === 3 && motivoReprovacao ? { label: "Motivo", texto: motivoReprovacao }
                : null;

    return (
        <div className={styles.situacaoAnalise}>
            <div className={`${styles.resultadoAnaliseParcial} ${parecer === 1 ? styles.Favoravel
                : parecer === 2 ? styles.FavoravelRessalvas
                    : parecer === 3 ? styles.Reprovado
                        : styles.NaoAvaliado
                }`}>

                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>
                    <h3 className={styles.parecerTitulo}>
                        Parecer {tipoParecer}
                    </h3>
                    {documentos.length > 0 && (
                        <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                            {documentos.map((doc) => (
                                <BlueHoverButton
                                    key={doc.Id}
                                    onClick={() => onDownloadParecer(projetoId)}
                                >
                                    Visualizar parecer análise
                                </BlueHoverButton>
                            ))}
                        </div>
                    )}
                </div>

                <div className={styles.parecerSituacao}>
                    Situação: {situacaoLabel}
                    <p>
                        {situacaoIcon && (
                            <FontAwesomeIcon size="lg" icon={situacaoIcon} />
                        )}
                    </p>
                </div>

                <p
                    className={styles.observacao}
                    style={{ visibility: observacao ? "visible" : "hidden" }}
                >
                    {observacao ? <PopupTexto texto={observacao.texto} titulo={observacao.label} /> : "–"}
                </p>

            </div>
        </div>
    );
};

const VisualizarAnalise = ({ record }) => {
    const [openDownload, setOpenDownload] = useState(false);
    const [severity, setSeverity] = useState("info");
    const [downloadMessage, setDownloadMessage] = useState("");

    const handleCloseInfo = (event, reason) => {
        if (reason === "clickaway") return;
        setOpenDownload(false);
    };

    const handleDownloadParecer = async (documentoId) => {
        if (!documentoId) return;

        try {
            setOpenDownload(true);
            setSeverity("info");
            setDownloadMessage("Iniciando download do documento...");

            const data = await servAnalises.VisualizarDocumentoParecerAnaliseProjeto(documentoId);

            setSeverity("success");
            setDownloadMessage("Download iniciado com sucesso...");

            const extensao = data.Content.Extensao || "pdf";
            const nome = data.Content.Nome || "documento";
            const mimeType = extensao === "docx"
                ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                : "application/pdf";

            var blob = base64toBlob(data.Content.Arquivo, mimeType);

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, `${nome}.${extensao}`);
            } else {
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = `${nome}.${extensao}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(blobUrl);
            }
        } catch (err) {
            setSeverity("error");
            setOpenDownload(true);
            let statusErrorMessage = err.response?.status + " - " + err.response?.statusText;
            setDownloadMessage(err.response?.data?.Message ? err.response.data.Message : statusErrorMessage);
        }
    };

    if (!record) {
        return (
            <div className={styles["resultado-analise"]}>
                <Box style={{ margin: "25px auto 0 auto" }}>Análise não encontrada.</Box>
            </div>
        );
    }

    const { Documentacao, Projeto } = record;

    return (
        <>
            <div className={styles.modalMain}>
                <SituacaoAnalise
                    tipoParecer="da documentação"
                    parecer={Documentacao?.Parecer}
                    motivoReprovacao={Documentacao?.MotivoReprovacao}
                    ressalva={Documentacao?.Ressalva}
                />
                <SituacaoAnalise
                    tipoParecer="do projeto"
                    parecer={Projeto?.Parecer}
                    motivoReprovacao={Projeto?.MotivoReprovacao}
                    ressalva={Projeto?.Ressalva}
                    projeto={Projeto}
                    onDownloadParecer={handleDownloadParecer}
                />
            </div>
            <Snackbar
                open={openDownload}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                autoHideDuration={1000}
                onClose={handleCloseInfo}
            >
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: "100%" }}>
                    {downloadMessage}
                </Alert>
            </Snackbar>
        </>
    );
};

export { VisualizarAnalise };